import React from 'react';
import PropTypes from 'prop-types';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { CustomInput } from '../CustomInput';
import { ReactComponent as calendarIcon } from '../../assets/images/calendar.svg';
import { DateTimePicker } from '@mui/x-date-pickers';
import { isWeekend } from 'date-fns';

export const CustomDateTimePicker = ({
  setFieldValue,
  name,
  value,
  offLastDate = true,
  onChange,
  disabled = false,
  showSeconds = false,
  ...props
}) => {
  function disableWeekends(date) {
    return new Date().valueOf() - 86400000 > date.valueOf() || isWeekend(date);
  }
  const handlerOnchange = (newValue) => {
    if (setFieldValue) {
      setFieldValue(name, newValue);
    } else {
      onChange(newValue);
    }
  };
  const inputFormat = showSeconds ? "dd/MM/yyyy HH:mm:ss" : "dd/MM/yyyy HH:mm";

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        inputFormat={inputFormat}
        shouldDisableDate={offLastDate && disableWeekends}
        value={value}
        onChange={handlerOnchange}
        components={{
          OpenPickerIcon: calendarIcon
        }}
        disabled={disabled}
        ampm={false}
        renderInput={(params) => {
          const {
            // eslint-disable-next-line no-unused-vars
            inputProps: { placeholder, ...inputProps },
            ...otherParams
          } = params;

          return <CustomInput {...props} {...inputProps} {...otherParams} error={props?.error} />;
        }}
      />
    </LocalizationProvider>
  );
};

CustomDateTimePicker.propTypes = {
  error: PropTypes.any,
  value: PropTypes.any,
  setFieldValue: PropTypes.func,
  name: PropTypes.string,
  offLastDate: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  showSeconds: PropTypes.bool
};
